var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotInterested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8214 8.1451L46.4391 25.9451C46.754 27.484 46.3581 29.0678 45.3684 30.2828C44.3692 31.4975 42.9025 32.1995 41.3274 32.1995H32.6161L34.047 39.228C34.3709 40.857 33.957 42.5307 32.9129 43.8087C31.8602 45.0957 30.3032 45.8335 28.6384 45.8335H27.1896C26.0645 45.8335 25.1466 44.9247 25.1466 43.8087C25.1466 41.3881 24.2378 35.0527 15.9405 28.6901L15.5895 28.4201V7.52409L17.6953 5.93124C18.9104 5.01337 20.4221 4.50944 21.943 4.50944H38.3661C40.5174 4.50906 42.3894 6.03894 42.8214 8.14474L42.8214 8.1451Z",
    fill: "#E53E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4043 4.16687H4.72808V4.16726C3.95407 4.16726 3.33337 4.78833 3.33337 5.5529V28.7977C3.33337 29.5713 3.95409 30.1924 4.72808 30.1924H12.4043C13.1693 30.1924 13.7903 29.5717 13.7903 28.7977V5.5529C13.7903 4.78795 13.1693 4.16687 12.4043 4.16687ZM11.1893 10.0255C11.1893 11.2311 10.2176 12.2032 9.02067 12.2032C7.81504 12.2032 6.83388 11.2311 6.83388 10.0255C6.83388 8.81081 7.81466 7.83872 9.02067 7.83872C10.2176 7.83872 11.1893 8.81043 11.1893 10.0255ZM9.08242 22.9099C10.3405 22.9099 11.3603 23.9297 11.3603 25.1878C11.3603 26.4458 10.3405 27.4657 9.08242 27.4657C7.82437 27.4657 6.80452 26.4458 6.80452 25.1878C6.80452 23.9297 7.82437 22.9099 9.08242 22.9099Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInterested);
export default __webpack_public_path__ + "static/media/NotInterested.dde59b2881e206061068d53c8455c154.svg";
export { ForwardRef as ReactComponent };